import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    headState: 'search',
    headTitle: '',
    searchWord: '',
  },
  mutations: {
    chageHeadState(state, headState) {
      if(window.innerWidth < 767){
        state.headState = headState
      }else{
        state.headState = 'search'
      }
    },
    chageHeadTitle(state, headTitle) {
      state.headTitle = headTitle
    },
    chageSearchWord(state, searchWord) {
      state.searchWord = searchWord
    },
  },
  actions: {
    changePage({ commit }, meta) {
      // console.log(meta)
      commit('chageHeadState', meta.headState)
      commit('chageHeadTitle', meta.title)
      commit('chageSearchWord', '')
    }
  },
  getters: {
    getHeadTitle(state) {
      return state.headTitle;
    },
    getHeadState(state) {
      return state.headState;
    },
    getSearchWord(state) {
      return state.searchWord;
    },
  }
})
export default store;
